import { createContext, useContext } from 'react';

import type { WalletType } from '@/context/types';
import type { MigrationRecovery, MigrationWallet } from '@/hooks/api/quanta/walletMigration';

export type MigrationStep =
  | 'idle'
  | 'select-source'
  | 'authenticate-source'
  | 'verify-owner'
  | 'linked-elsewhere'
  | 'preparing'
  | 'connect'
  | 'approving-source'
  | 'approving-target'
  | 'submitting'
  | 'recover'
  | 'completed';
export interface MigrationFlow {
  active: boolean;
  available: boolean;
  availabilityLoading: boolean;
  canCombine?: boolean;
  reverse?: boolean;
  connectSource?: (provider: WalletType) => Promise<void>;
  step: MigrationStep;
  busy: boolean;
  error: string | null;
  checkedSourceAddresses?: string[];
  recovery: MigrationRecovery | null;
  sourceAddress?: string;
  sourceProvider?: WalletType;
  sourceReady?: boolean;
  targetAddress?: string;
  existingLink?: string;
  requiredOwner?: MigrationWallet;
  verifyOwner?: (provider: WalletType) => Promise<void>;
  recoverWithOwner?: (provider: WalletType) => Promise<void>;
  alreadyLinked?: boolean;
  addressesMatch?: boolean;
  chooseAnotherSource?: () => void;
  begin: () => Promise<boolean>;
  approve: () => Promise<void>;
  recover: () => Promise<void>;
  cancel: () => Promise<void>;
  dismiss: () => void;
  retryAvailability: () => void;
}
export const QuantaMigrationContext = createContext<MigrationFlow | null>(null);
export const useQuantaMigration = () => useContext(QuantaMigrationContext);
